// @flow
import React, { Component, type Node } from 'react';
import ScrollToTop from 'components/common/ScrollToTop';
import './SectionsTemplate.scss';

type Props = {
  children: Node,
};

class SectionsTemplate extends Component<Props> {
  render() {
    const { children } = this.props;
    return <div className="SectionsTemplate">{children}</div>;
  }
}

export default SectionsTemplate;



// WEBPACK FOOTER //
// ./src/components/sections/SectionsTemplate/SectionsTemplate.js